import React from 'react'

import { PerksReimbursementDueResponse } from 'core/application/adminDashboard/reimbursements/perks/getPerksReimbursementDue'

import { formatMoney } from 'common/moneyFormatter'

interface PerksTotalReimbursementsDueProps {
  reimbursementsDue: PerksReimbursementDueResponse[]
  total: string
  translate: (key: string) => string
}

const TotalReimbursementsDue: React.FC<PerksTotalReimbursementsDueProps> = ({
  reimbursementsDue,
  translate,
  total,
}) => {
  return reimbursementsDue.length > 0 ? (
    <div className="total_reimbursements_due_wrap">
      {!reimbursementsDue.some((x) => x.offerSameAllowance) && (
        <div className="perks_total_reimbursements_due">
          <h6 className="pr-24">{translate('admin-dashboard.reimbursements.perks-reimbursements-due.total-label')}:</h6>
          <h6>
            <span className="color-gray-9 semi-bold">
              {formatMoney(reimbursementsDue.reduce((total, current) => total + current.reimbursementsDue, 0))}
            </span>
          </h6>
        </div>
      )}

      <div className="perks_total_reimbursements_due selected_total_bg">
        <h6 className="pr-40">
          {translate('admin-dashboard.reimbursements.perks-reimbursements-due.total-selected-label')}:
        </h6>
        <h6 className="">
          <span className="color-gray-9 semi-bold">{total}</span>
        </h6>
      </div>
    </div>
  ) : (
    <div></div>
  )
}

export default TotalReimbursementsDue
